import styled from "styled-components";

export const SelectBoxWrapper = styled.div`
  .css-1flyd4j-control,
  .css-13cymwt-control,
  [class*="-control"] {
    min-height: 48px !important;
  }
`;